import { render, staticRenderFns } from "./FetchMessagesButton.vue?vue&type=template&id=5aa3a392&"
import script from "./FetchMessagesButton.vue?vue&type=script&lang=js&"
export * from "./FetchMessagesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports